<template>
    <v-autocomplete
        v-model="result"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        color="white"
        item-text="name"
        item-value="id"
        :label="placeholder"
        :placeholder="placeholder"
        :disabled="disabled"
        outline
        single-line
        hide-details
        deletable-chips
        return-object
        clearable
    ></v-autocomplete>
</template>

<script>

import OrganizationApi from '@/api/OrganizationApi'

const organizationApi = new OrganizationApi()

export default {
    name: 'SubOrganizationAutocomplete',
    data () {
        return {
            isLoading: false,
            items: [],
            entries: [],
            search: null
        }
    },
    props: {
        organizationId: {
            type: String,
            default: ''
        },
        value: {
            type: [Object, Array, null]
        },
        searchAll: {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Start typing to search'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch: {
        search: {
            handler: function (value, oldVal) {
                if (!this.searchAll) {
                    this.getOrganizations(value)
                }
            },
            deep: true
        }
    },
    computed: {
        result: {
            get () {
                if (null != this.value && this.items.indexOf(this.value)) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.items.push(this.value)
                }
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    mounted () {
        this.getOrganizations()
    },
    methods: {
        async getOrganizations (value) {
            const response = await organizationApi.getSubOrganizations(this.organizationId)
            this.items = response.payload.items
        }
    }
}
</script>

<style scoped>

</style>
